import { type EnvironmentInjector, inject } from '@angular/core';

import { type LazyComponentDetails } from '@core/shared/util';
import { LoginContextService } from '@mpk/shared/data-access';
import { type SettingsFormPlugin, type SettingsFormPluginComponent } from '@mpk/shared/util';

import { EcosioSettingsPermissions } from '../permissions';

/**
 * Factory to create the ecosio settings plugin.
 */
export function createEcosioSettingsPlugin(): SettingsFormPlugin {
  const loginContextService = inject(LoginContextService);

  return {
    settingsId: 'EcosioSettings',
    displayName: 'ECOSIO',
    description: 'API-Konfiguration des ECOSIO Adapters',
    isEnabled: loginContextService.permission(EcosioSettingsPermissions.ManageSettings),
    async getComponentDetails(
      parentInjector: EnvironmentInjector,
    ): Promise<LazyComponentDetails<SettingsFormPluginComponent>> {
      const { EcosioSettingsEditComponent } = await import('../components');

      return {
        component: EcosioSettingsEditComponent,
        environmentInjector: parentInjector,
      };
    },
  };
}
